import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("sl_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("sl_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("sl_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("sl_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("sl_token");
    setUser(null);
  };

  /** Used by Google OAuth return page: hydrate context from token + /auth/me payload. */
  const setUserAndToken = (userObj, token) => {
    if (token) localStorage.setItem("sl_token", token);
    if (userObj) setUser(userObj);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setUser, setUserAndToken }}>
      {children}
    </AuthCtx.Provider>
  );
}
